/*
 * @Date: 2022-07-04 16:39:52
 * @LastEditors: chuhongguang
 */
import { createI18n } from "vue-i18n";

import zh from './lang/zh'
import zhHant from './lang/zh-hant'
import en from './lang/en'

const i18n = createI18n({
  locale: 'zh', //设置本地语言
  messages: {
    zh,
    zhHant,
    en
  }
})

export default i18n